<ngx-spinner type="ball-spin"></ngx-spinner>
<app-preloader></app-preloader>
<router-outlet></router-outlet>